import React, { useState, useEffect } from 'react';
import resources from '../../../services';
import Btn from '../../../ui/Btn';
import Select from 'react-select';
import { Field } from '../../../ui/Field';
import CreatePage from '../../../composents/CreatePage';

const title = 'Groups';
const headers = {
	icon: 'feather icon-plus',
	title: title,
	description: 'creation of new group',
	breadcrumbs: [
		{
			title: title,
			link: '/administrators/groups',
		},
	],
};

export default function CreateGroup() {
	const [loader, setLoader] = useState(false),
		[errors, setErrors] = useState({}),
		[clients, setClients] = useState([]),
		[client, setClient] = useState(),
		[group, setGroup] = useState(),
		[customers, setCustomers] = useState([]),
		[customer, setCustomer] = useState(),
		groups = [
			{
				value: 'countries',
				label: 'Countries',
			},
			{
				value: 'cities',
				label: 'Cities',
			},
			{
				value: 'entities',
				label: 'HD-entity',
			},
			{
				value: 'clients',
				label: 'Clients',
			},
			{
				value: 'consumers',
				label: 'Consumers',
			},
			{
				value: 'zones',
				label: 'Zones',
			},
			{
				value: 'meters',
				label: 'Meters',
			},
			{
				value: 'restrictions',
				label: 'Restrictions',
			},
			{
				value: 'subscriptions',
				label: 'Subscription',
			},

			{
				value: 'cards',
				label: 'Water cards',
			},
			{
				value: 'consumptions',
				label: 'Consumptions',
			},
			{
				value: 'recharges',
				label: 'Top Up',
			},
			// {
			// 	value: 'general stats',
			// 	label: 'General stats',
			// },

			{
				value: 'permissions',
				label: 'Permissions',
			},
			{
				value: 'groups',
				label: 'Groups',
			},
			{
				value: 'users',
				label: 'Users',
			},
			{
				value: 'agents',
				label: 'Agents',
			},
		];

	async function onGet() {
		let customerData = await resources.customer
			.read('all')
			.then((responses) => {
				return responses;
			})
			.catch((error) => {
				return Object.assign({}, error).response;
			});
		if (customerData.status === 200) {
			let a = [];
			customerData.data.docs.forEach((el) => {
				a.push({
					value: el.id,
					label: el.name,
				});
			});
			setCustomers(a);
		}
		let cli = await resources.permission
			.read('all')
			.then((responses) => {
				return responses;
			})
			.catch((error) => {
				return Object.assign({}, error).response;
			});
		if (cli.status === 200) {
			let a = [];
			cli.data.docs.forEach((el) => {
				a.push({
					value: el.id,
					label: el.title + ' ' + el.group,
					group: el.group,
				});
			});
			setClients(a);
		}
	}

	useEffect(() => {
		onGet();
	}, []);

	function onGetElement(params) {
		if (params) {
			let a = [];
			params.forEach((el) => {
				a.push(el.value);
			});

			setClient(a);
		}
	}

	/**
	 * @param {React.FormEvent<HTMLFormElement>} e
	 */
	async function onCreate(e) {
		e.preventDefault();
		let formData = new FormData(e.target);
		let object = {};
		formData.forEach((value, key) => (object[key] = value));
		object.permission = client;
		if (customer) object.client = customer.value;
		setLoader(true);
		setErrors({});
		let res = await resources.group
			.create(object)
			.then((responses) => {
				return responses;
			})
			.catch((error) => {
				return Object.assign({}, error).response;
			});

		setLoader(false);
		if (res.status === 200) {
			sessionStorage.setItem('success', true);
			window.location.replace('/administrators/groups');
		} else if (res.status === 422) {
			setErrors(
				res.data.errors.reduce((acc, error) => {
					return { ...acc, [error.field]: error.message };
				}, {})
			);
		} else if (res.status === 403) {
			setErrors({ not_autorized: true });
		}
	}

	const filterPermission = () => {
		if (group) {
			return clients.filter((g) => g.group === group.value);
		}

		return clients;
	};

	return (
		<CreatePage show_error={errors['not_autorized']} headers={headers}>
			<form onSubmit={onCreate}>
				<div className="row justify-content-center mt-3 mb-3">
					<div className="col-lg-6 ">
						<div className="card">
							<div className="card-header">
								<h5>Information</h5>
							</div>
							<div className="card-body">
								<div className="mb-3">
									<label
										htmlFor="exampleInputEmail1"
										className="form-label"
									>
										Client
									</label>
									<Select
										onChange={(e) => setCustomer(e)}
										options={customers}
										isSearchable
										isClearable
									/>
								</div>

								<Field
									name="title"
									className="mb-3"
									error={errors['title']}
									required
								>
									Title
								</Field>

								<Field
									name="role"
									className="mb-3"
									error={errors['role']}
									required
								>
									Type
								</Field>

								<div className="form-group mb-3">
									<label
										htmlFor="exampleInputEmail1"
										className="form-label"
									>
										Group of permission{' '}
										<span style={{ color: 'red' }}>*</span>
									</label>
									<Select
										onChange={setGroup}
										options={groups}
										isSearchable
										isClearable
									/>
								</div>

								<div className="mb-3">
									<label
										htmlFor="exampleInputEmail1"
										className="form-label"
									>
										Permissions{' '}
										<span style={{ color: 'red' }}>*</span>
									</label>
									<Select
										isMulti
										onChange={onGetElement}
										options={filterPermission()}
										className={
											errors['permission']
												? ' is-invalid'
												: ''
										}
									/>
									{errors['permission'] && (
										<div className="invalid-feedback">
											{errors['permission']}
										</div>
									)}
								</div>

								<Field
									name="description"
									type="textarea"
									error={errors['description']}
									className="mb-3"
								>
									Note
								</Field>

								<div className="row ">
									<div className="col-lg-12">
										<div className="d-grid gap-2">
											<Btn
												class="btn waves-effect waves-light btn-primary"
												onLoad={loader}
											>
												<i className="feather icon-save"></i>{' '}
												Submit
											</Btn>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</form>
		</CreatePage>
	);
}
